import runtimeEnv from '@mars/heroku-js-runtime-env';

const env = runtimeEnv();

export const GRAPHQL_URL =
  process.env.NODE_ENV === 'production'
    ? env.REACT_APP_STAGING_URL
    : env.REACT_APP_DEVELOP_URL;

export const API_URL = GRAPHQL_URL.replace(/\/graphql$/, '');
